jPar.wdk = jPar.wdk || {};
$j.extend(true, jPar.wdk, {
	loadingIndicator: {
		indicatorTimer: null,

		show: function show(clickedElement) {
			this.stopTimer();

			if (clickedElement !== null) {
				if (clickedElement.length > 1) {
					// Kann auch eine nodeList übegeben werden
					if (clickedElement instanceof jQuery) {
						clickedElement = clickedElement.toArray();
					}
					clickedElement.forEach(function (elem) {
						elem.classList.add('disabled');
						elem.disabled = true;

						this.indicatorTimer = window.setTimeout(function () {
							elem.classList.add('is-loading');
						}, 1500);
					});
				} else {
					if (clickedElement instanceof jQuery) {
						clickedElement = clickedElement[0];
					}

					if (clickedElement !== undefined) {
						// Nach dem casten aus einem jQuery Element kann sich herausstellen, das es das element doch gar nicht gibt.
						clickedElement.classList.add('disabled');
						clickedElement.disabled = true;

						this.indicatorTimer = window.setTimeout(function () {
							clickedElement.classList.add('is-loading');
						}, 1500);
					}
				}
			}
		},

		hide: function hide(clickedElement) {
			this.stopTimer();

			if (clickedElement !== null) {
				if (clickedElement.length > 1) {
					// Kann auch eine nodeList übegeben werden
					if (clickedElement instanceof jQuery) {
						clickedElement = clickedElement.toArray();
					}
					clickedElement.forEach(function (elem) {
						elem.classList.remove('disabled', 'is-loading');
						elem.disabled = false;
					});
				} else {
					if (clickedElement instanceof jQuery) {
						clickedElement = clickedElement[0];
					}
					if (clickedElement !== undefined) {
						// Nach dem casten aus einem jQuery Element kann sich herausstellen, das es das element doch gar nicht gibt.
						clickedElement.classList.remove('disabled', 'is-loading');
						clickedElement.disabled = false;
					}
				}
			}
		},

		stopTimer: function stopTimer() {
			window.clearTimeout(this.indicatorTimer);
		},
	},
});
